<template>
  <v-alert
    id="ErrorComponent"
    v-model="show"
    class="errors"
    outlined
    type="error"
    prominent
    border="left"
    dismissible
  >
    <div v-if="errorsArray.length > 0">
      <v-expansion-panels
        accordion
        flat
      >
        <v-expansion-panel
          v-for="(item, key) in errorsArray"
          :key="key"
        >
          <v-expansion-panel-header>{{ item.message }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul v-if="item.errors">
              <li
                v-for="(error, index) in item.errors"
                :key="index"
              >
                {{ error[0] }}
              </li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-else>
      <span>{{ errors.message }}</span>
      <ul v-if="errors.errors">
        <li
          v-for="(error, index) in errors.errors"
          :key="index"
        >
          {{ error[0] }}
        </li>
      </ul>
    </div>
    <template v-slot:close>
      <button
        class="close"
        @click="$emit('close')"
      >
        <v-icon
          color="error"
        >
          mdi-close
        </v-icon>
      </button>
    </template>
  </v-alert>
</template>
<script>
export default {
  name: 'Error',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },
    errorsArray: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang='scss'>
  #ErrorComponent {

    background: white !important;

    .close {
      align-self: start;
    }
    .v-expansion-panel {
      background: transparent !important;
      color: red !important;
    }
  }
  .v-alert--prominent .v-alert__icon::after{
      background: none !important;
    }
</style>
